import { EMPLOYEES_ACTIONS } from 'Actions/index';
import { DATA_LOAD_STATUS } from 'Utils/constants';
import { ICON_COLOR_STYLE_NAMES } from 'Utils/customStyling';
import { PAGE_ACTIONS } from 'Utils/constants';

const initialState = {
  contentStatus: {
    summary: DATA_LOAD_STATUS.LOADING,
    data: DATA_LOAD_STATUS.LOADING,
  },
  summaryItems: [
    {
      label: 'Requests',
      value: 15,
      colorStyleName: ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_PURPLE,
    },
    {
      label: 'Onboarded',
      value: 25,
      colorStyleName: ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_GREEN,
    },
    {
      label: 'In-Progress',
      value: 45,
      colorStyleName: ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_ORANGE,
    },
    {
      label: 'Renege',
      value: 5,
      colorStyleName: ICON_COLOR_STYLE_NAMES.ICON_COLOR_STYLE_RED,
    },
  ],
  employees: [{}, {}, {}, {}, {}, {}],
  currentSelection: null,
  currentAction: PAGE_ACTIONS.VIEW,
  currentPage: 1,
  totalPages: 1,
  hasNextPage: false,
  hasPrevPage: false,
  searchMode: false,
};

const {
  GET_EMPLOYEES,
  SELECT_EMPLOYEE,
  GET_SUMMARY,
  SET_CONTENT_DATA_LOADING,
  SET_EMPLOYEE_CURRENT_ACTION,
} = EMPLOYEES_ACTIONS;

const employees = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMPLOYEES:
      return {
        ...state,
        contentStatus: {
          ...state.contentStatus,
          data: DATA_LOAD_STATUS.LOADED,
        },
        employees: action.payload.docs,
        currentSelection: action.payload.docs[0]
          ? action.payload.docs[0]['_id']
          : null,
        currentAction: action.payload.docs[0]
          ? PAGE_ACTIONS.VIEW
          : PAGE_ACTIONS.NO_RESULTS,
        currentPage: action.payload.page,
        totalPages: action.payload.totalPages,
        hasNextPage: action.payload.hasNextPage,
        hasPrevPage: action.payload.hasPrevPage,
      };
    case SELECT_EMPLOYEE:
      return {
        ...state,
        currentSelection: action.payload,
        currentAction: PAGE_ACTIONS.VIEW,
      };
    case GET_SUMMARY:
      return {
        ...state,
        contentStatus: {
          ...state.contentStatus,
          summary: DATA_LOAD_STATUS.LOADED,
        },
        summaryItems: [
          {
            ...state.summaryItems[0],
            value: action.payload.total,
          },
          {
            ...state.summaryItems[1],
            value: action.payload.completed,
          },
          {
            ...state.summaryItems[2],
            value: action.payload.inProgress,
          },
          {
            ...state.summaryItems[3],
            value: action.payload.pending,
          },
        ],
      };
    case SET_CONTENT_DATA_LOADING:
      return {
        ...state,
        contentStatus: {
          ...state.contentStatus,
          data: DATA_LOAD_STATUS.LOADING,
        },
        currentAction: PAGE_ACTIONS.VIEW,
      };
    case SET_EMPLOYEE_CURRENT_ACTION:
      return {
        ...state,
        currentAction:
          !state.currentSelection &&
          state.currentAction !== PAGE_ACTIONS.NO_RESULTS
            ? PAGE_ACTIONS.NO_RESULTS
            : action.payload,
      };
    default:
      return state;
  }
};

export default employees;
